export enum MangaFormat {
    IMAGE = 0,
    ARCHIVE = 1,
    UNKNOWN = 2,
    EPUB = 3,
    PDF = 4
}